import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ProspectosCreate from "./ProspectosCreate";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import ESTADOS_MEXICO from "../estadosMexico";
import { puede } from "../../../../permisos/permisos";
import { etiquetasEtapas, nombreEtapa } from "../etapas";
import { NIVELES_INTERES } from "./interes";

// Caja de monto con su etiqueta adentro; se escribe con comas y al padre le llega solo el numero.
function FiltroValor({ etiqueta, valor, onChange }) {
  return (
    <div className="filtro-valor">
      <span>{etiqueta}</span>
      <input
        type="text"
        inputMode="numeric"
        placeholder="Todos"
        value={valor ? `$${Number(valor).toLocaleString("es-MX")}` : ""}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
      />
    </div>
  );
}

// Filtro de seleccion multiple: buscador + lista con checkboxes; lo marcado se ve como badges.
// opciones: [{ _id, etiqueta, extra?, color? }]
function FiltroMulti({ opciones, seleccion, onChange, placeholder, nombre, maximo = 60 }) {
  const [buscar, setBuscar] = useState("");
  const [abierto, setAbierto] = useState(false);

  const toggle = (id) =>
    onChange(seleccion.includes(id) ? seleccion.filter((x) => x !== id) : [...seleccion, id]);

  const visibles = opciones
    .filter((o) => {
      if (!buscar) return true;
      const t = buscar.toLowerCase();
      return (o.etiqueta || "").toLowerCase().includes(t) || (o.extra || "").toString().toLowerCase().includes(t);
    })
    .slice(0, maximo);

  return (
    <>
      <div style={{ position: "relative" }}>
        <Input
          type="text"
          placeholder={seleccion.length ? `${seleccion.length} ${nombre}(s) seleccionado(s)` : placeholder}
          value={buscar}
          onChange={(e) => {
            setBuscar(e.target.value);
            setAbierto(true);
          }}
          onFocus={() => setAbierto(true)}
        />
        {abierto && (
          <div
            style={{
              position: "absolute",
              zIndex: 20,
              top: "100%",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1px solid #e2e8f0",
              borderRadius: 6,
              boxShadow: "0 6px 16px rgba(0,0,0,.12)",
              maxHeight: 280,
              overflowY: "auto",
              padding: 6,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 4px 6px" }}>
              <small className="text-muted">
                {visibles.length === maximo ? `Mostrando ${maximo}, afina la búsqueda` : `${visibles.length} ${nombre}(s)`}
              </small>
              <div>
                {seleccion.length > 0 && (
                  <Button size="sm" color="link" style={{ padding: "0 6px" }} onClick={() => onChange([])}>
                    Limpiar
                  </Button>
                )}
                <Button size="sm" color="link" style={{ padding: "0 6px" }} onClick={() => setAbierto(false)}>
                  Cerrar
                </Button>
              </div>
            </div>
            {visibles.map((o) => (
              <label
                key={o._id}
                style={{ display: "flex", alignItems: "center", gap: 8, padding: "3px 4px", margin: 0, cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  checked={seleccion.includes(o._id)}
                  onChange={() => toggle(o._id)}
                  style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                />
                <span>{o.etiqueta}</span>
                {o.extra ? <small className="text-muted">{o.extra}</small> : null}
              </label>
            ))}
          </div>
        )}
      </div>
      {seleccion.length > 0 && (
        <div style={{ marginTop: 4 }}>
          {seleccion.map((id) => {
            const o = opciones.find((x) => x._id === id);
            return (
              <span
                key={id}
                className="badge"
                style={{
                  backgroundColor: (o && o.color) || "#e2e8f0",
                  color: o && o.color ? "#fff" : "#334155",
                  marginRight: 3,
                  marginBottom: 2,
                  display: "inline-block",
                  cursor: "pointer",
                }}
                title="Quitar del filtro"
                onClick={() => toggle(id)}
              >
                {o ? o.etiqueta : id} &times;
              </span>
            );
          })}
        </div>
      )}
    </>
  );
}

function ListadoProspectos() {
  const { user } = useContext(AuthContext);
  const URL_CRM_PROSPECTOS = process.env.REACT_APP_URL_CRM_PROSPECTOS;
  const URL_CRM_CATEGORIAS = process.env.REACT_APP_URL_CRM_CATEGORIAS;
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [prospectos, setProspectos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [search, setSearch] = useState("");
  const [filtroCategorias, setFiltroCategorias] = useState([]);
  const [filtroMaquinas, setFiltroMaquinas] = useState([]);
  const [filtroProductos, setFiltroProductos] = useState([]);
  const [filtroInteres, setFiltroInteres] = useState([]);
  // Rango de valor del prospecto; vacio o 0 = sin filtro.
  const [valorMin, setValorMin] = useState("");
  const [valorMax, setValorMax] = useState("");
  const [maquinas, setMaquinas] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const etiquetaEtapa = etiquetasEtapas(etapas);

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  // Modal de oportunidades del prospecto
  const [modalOp, setModalOp] = useState(false);
  const toggleOp = () => setModalOp(!modalOp);
  const [oportunidades, setOportunidades] = useState([]);
  const [prospectoSel, setProspectoSel] = useState("");

  const [idEdit, setIdEdit] = useState();
  const [razon_social, setRazonSocial] = useState("");
  const [contacto, setContacto] = useState("");
  const [cargo, setCargo] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [RFC, setRFC] = useState("");
  const [origen, setOrigen] = useState("");
  const [interes, setInteres] = useState("");
  const [estado, setEstado] = useState("");
  const [categoriasSel, setCategoriasSel] = useState([]);
  const [articulosSel, setArticulosSel] = useState([]);
  const [buscarArticulo, setBuscarArticulo] = useState("");
  const [notas, setNotas] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [responsable, setResponsable] = useState("");
  const [maquinasSel, setMaquinasSel] = useState([]);
  const [valor_estimado, setValorEstimado] = useState(0);
  const [opId, setOpId] = useState("");

  useEffect(() => {
    getProspectos();
    const h = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios.get(URL_CRM_CATEGORIAS, h).then((r) => setCategorias(r.data)).catch((e) => console.log(e));
    axios.get(URL_COLABORADORES, h).then((r) => setUsuarios(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_ARTICULOS, h).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_MAQUINAS, h).then((r) => setMaquinas(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_CRM_ETAPAS, h).then((r) => setEtapas(r.data)).catch((e) => console.log(e));
  }, []);

  function toggleCategoria(id) {
    setCategoriasSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  // Activos + los ya seleccionados, filtrados por el buscador (codigo o descripcion).
  const articulosFiltrados = articulos
    .filter((a) => a.is_active === "Si" || articulosSel.includes(a._id))
    .filter((a) => {
      if (!buscarArticulo) return true;
      const s = buscarArticulo.toLowerCase();
      return (
        (a.descripcion || "").toLowerCase().includes(s) ||
        (a.codigo || "").toString().toLowerCase().includes(s)
      );
    })
    .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1));

  function toggleArticulo(id) {
    setArticulosSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  // Maquinas del prospecto (soporta el campo viejo `maquina` hasta que corra la migracion).
  const maquinasDe = (a) =>
    (a.maquinas && a.maquinas.length ? a.maquinas : a.maquina ? [a.maquina] : []).map((m) =>
      // Si viene solo el id (campo viejo sin populate) se resuelve contra el catalogo cargado.
      m && m.nombre ? m : maquinas.find((x) => x._id === (m && m._id ? m._id : m)) || m
    );

  function toggleMaquinaSel(id) {
    setMaquinasSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  const opcionesMaquinasFiltro = [{ _id: "sin", etiqueta: "Sin máquina" }].concat(
    maquinas
      .slice()
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((m) => ({ _id: m._id, etiqueta: m.nombre, color: "#0ea5e9" }))
  );

  const nivelInteres = (a) => NIVELES_INTERES.find((n) => n._id === a.interes);
  const opcionesInteresFiltro = NIVELES_INTERES.concat({ _id: "sin", etiqueta: "Sin definir" });

  // Opciones de los filtros multi (productos: activos + los ya marcados).
  const opcionesProductosFiltro = articulos
    .filter((a) => a.is_active === "Si" || filtroProductos.includes(a._id))
    .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
    .map((a) => ({ _id: a._id, etiqueta: a.descripcion || a.codigo, extra: a.codigo }));
  const opcionesCategoriasFiltro = categorias
    .slice()
    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
    .map((c) => ({ _id: c._id, etiqueta: c.nombre, color: c.color || "#6366f1" }));

  function getProspectos() {
    axios
      .get(URL_CRM_PROSPECTOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setProspectos(response.data))
      .catch((err) => console.log(err));
  }

  function jalaInfo(a) {
    setIdEdit(a._id);
    setRazonSocial(a.razon_social);
    setContacto(a.contacto || "");
    setCargo(a.cargo || "");
    setEmail(a.email || "");
    setTelefono(a.telefono || "");
    setWhatsapp(a.whatsapp || "");
    setEmpresa(a.empresa || "");
    setRFC(a.RFC || "");
    setOrigen(a.origen || "");
    setInteres(a.interes || "");
    setEstado(a.estado || "");
    setCategoriasSel((a.categorias || []).map((c) => (c._id ? c._id : c)));
    setArticulosSel((a.articulosInteres || []).map((x) => (x._id ? x._id : x)));
    setMaquinasSel(maquinasDe(a).map((m) => m._id || m));
    setBuscarArticulo("");
    setNotas(a.notas || "");
    // Precarga responsable/valor desde la oportunidad del prospecto.
    setResponsable("");
    setValorEstimado(0);
    setOpId("");
    axios
      .get(`${URL_CRM_PROSPECTOS}/${a._id}/oportunidades`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => {
        const op = (r.data || [])[0];
        if (op) {
          setOpId(op._id);
          setResponsable(op.responsable ? (op.responsable._id || op.responsable) : "");
          setValorEstimado(op.valor_estimado || 0);
        }
      })
      .catch((e) => console.log(e));
    toggle();
  }

  function editProspecto(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_CRM_PROSPECTOS}/${idEdit}`,
        { razon_social, contacto, cargo, email, telefono, whatsapp, empresa, RFC, origen, interes, estado, categorias: categoriasSel, articulosInteres: articulosSel, maquinas: maquinasSel, notas },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar Prospecto", detalle: razon_social, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        const finalizar = () => {
          toggle();
          Swal.fire("Good job!", "Actualizado con exito", "success");
          window.location.reload();
        };
        // Actualiza responsable/valor en la oportunidad del prospecto.
        if (opId) {
          axios
            .patch(
              `${URL_CRM_OPORTUNIDADES}/${opId}`,
              { responsable, valor_estimado: Number(valor_estimado) || 0 },
              { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
            )
            .then(finalizar)
            .catch(finalizar);
        } else {
          finalizar();
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data : error}`,
        });
      });
  }

  function verOportunidades(a) {
    setProspectoSel(a.razon_social);
    axios
      .get(`${URL_CRM_PROSPECTOS}/${a._id}/oportunidades`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => {
        setOportunidades(response.data);
        toggleOp();
      })
      .catch((err) => console.log(err));
  }

  const prospectosFiltrados = prospectos.filter((a) => {
    // La busqueda tambien pega contra los productos de interes.
    const productos = (a.articulosInteres || [])
      .map((p) => `${p.codigo || ""} ${p.descripcion || ""}`)
      .join(" ");
    const t = `${a.razon_social} ${a.empresa} ${a.contacto} ${a.email} ${a.telefono} ${productos}`.toLowerCase();
    if (!t.includes(search.toLowerCase())) return false;
    if (
      filtroCategorias.length &&
      !(a.categorias || []).some((c) => filtroCategorias.includes(c._id || c))
    )
      return false;
    if (filtroInteres.length && !filtroInteres.includes(a.interes || "sin")) return false;
    if (filtroMaquinas.length) {
      const ids = maquinasDe(a).map((m) => m._id || m);
      const pegaSin = filtroMaquinas.includes("sin") && ids.length === 0;
      if (!pegaSin && !ids.some((id) => filtroMaquinas.includes(id))) return false;
    }
    if (
      filtroProductos.length &&
      !(a.articulosInteres || []).some((p) => filtroProductos.includes(p._id || p))
    )
      return false;
    const valor = Number(a.valor_estimado || 0);
    if (Number(valorMin) > 0 && valor < Number(valorMin)) return false;
    if (Number(valorMax) > 0 && valor > Number(valorMax)) return false;
    return true;
  });

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "crm.prospectos.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-user-plus" style={{ marginRight: 8, color: "#8b5cf6" }} />
                  Prospectos
                </h3>
                <p className="page-subtitle">Contactos y leads</p>
              </div>
              <div className="page-actions">
                {puede(user, "crm.prospectos.crear") && (
                  <Button size="sm" color="success" onClick={toggleCreate}>
                    <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Prospecto
                  </Button>
                )}
              </div>
            </div>
            <Row>
              <Col md={3}>
                <Input
                  type="text"
                  placeholder="Buscar..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <FiltroMulti
                  opciones={opcionesCategoriasFiltro}
                  seleccion={filtroCategorias}
                  onChange={setFiltroCategorias}
                  placeholder="Filtrar por categoría..."
                  nombre="categoría"
                />
              </Col>
              <Col md={3}>
                <FiltroMulti
                  opciones={opcionesInteresFiltro}
                  seleccion={filtroInteres}
                  onChange={setFiltroInteres}
                  placeholder="Filtrar por interés..."
                  nombre="nivel"
                />
              </Col>
              <Col md={3}>
                <FiltroMulti
                  opciones={opcionesMaquinasFiltro}
                  seleccion={filtroMaquinas}
                  onChange={setFiltroMaquinas}
                  placeholder="Filtrar por máquina..."
                  nombre="máquina"
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col md={6}>
                <FiltroMulti
                  opciones={opcionesProductosFiltro}
                  seleccion={filtroProductos}
                  onChange={setFiltroProductos}
                  placeholder="Filtrar por producto de interés..."
                  nombre="producto"
                />
              </Col>
              <Col md={3}>
                <FiltroValor etiqueta="Valor mayor que" valor={valorMin} onChange={setValorMin} />
              </Col>
              <Col md={3}>
                <FiltroValor etiqueta="Valor menor que" valor={valorMax} onChange={setValorMax} />
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Folio</th>
                  <th className="tituloTabla">Nombre / Razon social</th>
                  {/* <th className="tituloTabla">Empresa</th> */}
                  <th className="tituloTabla">Contacto</th>
                  <th className="tituloTabla">Telefono</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla">Categorías</th>
                  <th className="tituloTabla">Interés</th>
                  <th className="tituloTabla">Máquina</th>
                  <th className="tituloTabla">Productos de interés</th>
                  <th className="tituloTabla">Origen</th>
                  <th className="tituloTabla">Valor</th>
                  <th className="tituloTabla">Oportunidades</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {prospectosFiltrados.map((a) => (
                  <tr key={a._id}>
                    <td>{a.idProspecto}</td>
                    <td>{a.razon_social}</td>
                    {/* <td>{a.empresa}</td> */}
                    <td>{a.contacto}</td>
                    <td>{a.telefono}</td>
                    <td>{a.estado}</td>
                    <td>
                      {(a.categorias || []).map((c) => (
                        <span
                          key={c._id}
                          className="badge"
                          style={{ backgroundColor: c.color || "#6366f1", color: "#fff", marginRight: 3 }}
                        >
                          {c.nombre}
                        </span>
                      ))}
                    </td>
                    <td>
                      {nivelInteres(a) ? (
                        <span className="badge" style={{ backgroundColor: nivelInteres(a).color, color: "#fff" }}>
                          {nivelInteres(a).etiqueta}
                        </span>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      {maquinasDe(a).length === 0 ? (
                        <span className="text-muted">-</span>
                      ) : (
                        maquinasDe(a).map((m) => (
                          <span
                            key={m._id || m}
                            className="badge"
                            style={{ backgroundColor: "#0ea5e9", color: "#fff", marginRight: 3, marginBottom: 2, display: "inline-block" }}
                          >
                            {m.nombre || m}
                          </span>
                        ))
                      )}
                    </td>
                    <td style={{ minWidth: 220 }}>
                      {(a.articulosInteres || []).length === 0 ? (
                        <span className="text-muted">-</span>
                      ) : (
                        (a.articulosInteres || []).map((p) => (
                          <span
                            key={p._id}
                            className="badge"
                            style={{
                              backgroundColor: "#e2e8f0",
                              color: "#334155",
                              marginRight: 3,
                              marginBottom: 2,
                              display: "inline-block",
                            }}
                            title={`${p.codigo || ""} ${p.descripcion || ""}`.trim()}
                          >
                            {p.descripcion || p.codigo}
                          </span>
                        ))
                      )}
                    </td>
                    <td>{a.origen}</td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>
                      ${Number(a.valor_estimado || 0).toLocaleString("es-MX")}
                    </td>
                    <td>
                      <Button color="primary" size="sm" onClick={() => verOportunidades(a)}>
                        <i className="fas fa-handshake"></i>
                      </Button>
                    </td>
                    <td>
                      {puede(user, "crm.prospectos.editar") && (
<Button color="info" size="sm" onClick={() => jalaInfo(a)}>
                        <i className="far fa-edit"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      {/* Alta */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Nuevo Prospecto
        </ModalHeader>
        <ModalBody>
          <ProspectosCreate />
        </ModalBody>
      </Modal>

      {/* Edicion */}
      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-edit" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Editar Prospecto
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Nombre / Razon social</Label>
              <Input type="text" value={razon_social} onChange={(e) => setRazonSocial(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Estado (República)</Label>
              <Input type="select" value={estado} onChange={(e) => setEstado(e.target.value)}>
                <option value="">Selecciona...</option>
                {ESTADOS_MEXICO.map((es) => (
                  <option key={es} value={es}>{es}</option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Persona de contacto</Label>
              <Input type="text" value={contacto} onChange={(e) => setContacto(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Cargo</Label>
              <Input type="text" value={cargo} onChange={(e) => setCargo(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Telefono</Label>
              <Input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>WhatsApp</Label>
              <Input type="text" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>RFC</Label>
              <Input type="text" value={RFC} onChange={(e) => setRFC(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Origen del lead</Label>
              <Input type="select" value={origen} onChange={(e) => setOrigen(e.target.value)}>
                <option value="Web">Web</option>
                <option value="Referido">Referido</option>
                <option value="Llamada en frio">Llamada en frio</option>
                <option value="Feria">Feria / Expo</option>
                <option value="Recuperacion de Cliente">Recuperacion de Cliente</option>
                <option value="Redes sociales">Redes sociales</option>
                <option value="Recomendacion">Recomendacion</option>
                <option value="ClienteActual">Cliente Actual</option>
                <option value="Otro">Otro</option>
              </Input>
            </Col>
            <Col md={4}>
              <Label>Interés</Label>
              <Input type="select" value={interes} onChange={(e) => setInteres(e.target.value)}>
                <option value="">Sin definir</option>
                {NIVELES_INTERES.map((n) => (
                  <option key={n._id} value={n._id}>{n.etiqueta}</option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Responsable</Label>
              <Input type="select" value={responsable} onChange={(e) => setResponsable(e.target.value)}>
                <option value="">Sin asignar</option>
                {usuarios.map((u) => (
                  <option key={u._id} value={u._id}>{u.nombre} {u.apellido}</option>
                ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Valor estimado</Label>
              <Input
                type="number"
                value={valor_estimado}
                onChange={(e) => setValorEstimado(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Label>Máquinas (opcional)</Label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "2px 12px",
                  border: "1px solid #e2e8f0",
                  borderRadius: 6,
                  padding: 8,
                }}
              >
                {maquinas
                  .filter((m) => m.is_active !== "No" || maquinasSel.includes(m._id))
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((m) => (
                    <div key={m._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                      <input
                        type="checkbox"
                        checked={maquinasSel.includes(m._id)}
                        onChange={() => toggleMaquinaSel(m._id)}
                        style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                      />
                      <span>{m.nombre}</span>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Label>Categorías</Label>
              {/* En columnas para que quepan todas sin scroll. */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))",
                  gap: "2px 12px",
                  border: "1px solid #e2e8f0",
                  borderRadius: 6,
                  padding: 8,
                }}
              >
                {categorias.length === 0 ? (
                  <small className="text-muted">Sin categorías.</small>
                ) : (
                  categorias.map((c) => (
                    <div key={c._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                      <input
                        type="checkbox"
                        checked={categoriasSel.includes(c._id)}
                        onChange={() => toggleCategoria(c._id)}
                        style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                      />
                      <span>{c.nombre}</span>
                    </div>
                  ))
                )}
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Label>Artículos de interés (opcional)</Label>
              <Input
                type="text"
                placeholder="Buscar artículo..."
                value={buscarArticulo}
                onChange={(e) => setBuscarArticulo(e.target.value)}
                style={{ marginBottom: 8 }}
              />
              <div style={{ height: 240, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
                {articulosFiltrados.length === 0 ? (
                  <small className="text-muted">Sin artículos que coincidan.</small>
                ) : (
                  articulosFiltrados.map((a) => (
                    <div key={a._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                      <input
                        type="checkbox"
                        checked={articulosSel.includes(a._id)}
                        onChange={() => toggleArticulo(a._id)}
                        style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                      />
                      <span>{a.codigo ? `${a.codigo} / ` : ""}{a.descripcion}</span>
                    </div>
                  ))
                )}
              </div>
              {articulosSel.length > 0 && (
                <small className="text-muted">{articulosSel.length} artículo(s) seleccionado(s)</small>
              )}
            </Col>
          </Row>
          <br />
          <Label>Notas</Label>
          <Input type="textarea" value={notas} onChange={(e) => setNotas(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editProspecto}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Oportunidades del prospecto */}
      <Modal size="lg" isOpen={modalOp} toggle={toggleOp}>
        <ModalHeader toggle={toggleOp}>
          <i className="fas fa-handshake" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Oportunidades de {prospectoSel}
        </ModalHeader>
        <ModalBody>
          {oportunidades.length === 0 ? (
            <p>Sin oportunidades registradas.</p>
          ) : (
            <Table size="sm" striped borderless>
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Titulo</th>
                  <th>Etapa</th>
                  <th>Valor</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {oportunidades.map((o) => (
                  <tr key={o._id}>
                    <td>{o.idOportunidad}</td>
                    <td>{o.titulo}</td>
                    <td>{nombreEtapa(etiquetaEtapa, o.etapa) || "-"}</td>
                    <td>${Number(o.valor_estimado || 0).toLocaleString("es-MX")}</td>
                    <td>{o.estado}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoProspectos;
